// File: src/api/jobAPI.js

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL + `/jobs`;
const API_ESTIMATES = process.env.REACT_APP_API_URL + `/estimate`;

// Get the auth token from localStorage or authService
const getAuthToken = () => localStorage.getItem('token');

// Set the Authorization header with the tokenWZZZZZZZZ
const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getAuthToken()}`,
  },
});

// Fetch all jobs
export const fetchJobs = async () => {
  try {
    const response = await axios.get(API_URL, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching jobs:', error);
    throw error;
  }
};

// Fetch all jobs
export const fetchAcceptedEstimates = async (params) => {
  try {
    params = 'status=Accepted';
    const response = await axios.get(API_ESTIMATES+'/search?'+params, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching jobs:', error);
    throw error;
  }
};

// Create a new job
export const createJob = async (jobData) => {
  try {
    const response = await axios.post(API_URL, jobData, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error creating job:', error);
    throw error;
  }
};

// Update job status
export const updateJob = async (jobId, formData) => {
  try {
    const response = await axios.put(`${API_URL}/${jobId}`, {formData}, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error updating job:', error);
    throw error;
  }
};
// Update job status
export const updateJobStatus = async (jobId, status) => {
  try {
    const response = await axios.patch(`${API_URL}/${jobId}/status`, { status }, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error updating job status:', error);
    throw error;
  }
};

// Fetch a single job by ID
export const fetchJobById = async (jobId) => {
  try {
    const response = await axios.get(`${API_URL}/${jobId}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching job:', error);
    throw error;
  }
};

// Delete a job
export const deleteJob = async (jobId) => {
  try {
    await axios.delete(`${API_URL}/${jobId}`, getHeaders());
  } catch (error) {
    console.error('Error deleting job:', error);
    throw error;
  }
};

export const getJobsScheduled = async() => { 
  try {
    const response = await axios.get(API_URL+'/scheduled', getHeaders()); 
    return response.data; 
  } catch (error) {
    console.error('Error fetching jobs:', error); 
    throw error;
  }
}

// Function to save job costs to the financial table
export const saveJobCosts = async (job_id, costs) => {
  try {
    const response = await axios.post(`${API_URL}/${job_id}/costs`, { costs });
    return response.data;
  } catch (error) {
    console.error('Error saving job costs:', error);
    throw error;
  }
};

export const updateJobCost = async (job_id, cost_id, data) => {
  try {
    const response = await axios.put(`${API_URL}/${job_id}/costs/${cost_id}`, data, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error updating job cost:', error);
    throw error;
  }
};

export const deleteJobCost = async (job_id, cost_id) => {
  try {
    const response = await axios.delete(`${API_URL}/${job_id}/costs/${cost_id}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error deleting job cost:', error);
    throw error;
  }
};

// Fetch aggregated report data: totals, by_category, by_origin, by_service, optional per-job rows
export const fetchJobsReport = async (params = {}) => {
  try {
    const query = new URLSearchParams();
    if (params.start_date) query.append('start_date', params.start_date);
    if (params.end_date) query.append('end_date', params.end_date);
    if (Array.isArray(params.origin) && params.origin.length) query.append('origin', params.origin.join(','));
    if (Array.isArray(params.service) && params.service.length) query.append('service', params.service.join(','));
    if (Array.isArray(params.status) && params.status.length) query.append('status', params.status.join(','));
    if (params.group_by) query.append('group_by', params.group_by);
    const qs = query.toString();
    const response = await axios.get(`${API_URL}/report${qs ? `?${qs}` : ''}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching jobs report:', error);
    throw error;
  }
};